import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material' // making these changes till achar sanhita
import {
    HeroTopLeftMessage,
    HeroMantriStrip,
    HeroWrapper,
    PersonCard,
    PersonDesc,
    PersonPic,
} from './StyledComponent'
import { bannerCmStripData, bannerImgUrls } from './data' // bannerCmStripData,
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme) => ({
    parentContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    infoWrapper: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        height: '32px',
        padding: '0 8px',
        borderRadius: '4px',
        textShadow: '.5px .5px #CC8500',
        animation: '$backgroundChange 4s linear infinite',
    },
    info: {
        color: 'black',
        textAlign: 'center',
        fontWeight: 'bold',
        marginLeft: theme.spacing(1),
    },
    icon: {
        width: '32px',
        height: '16px',
    },
    '@keyframes backgroundChange': {
        '0%': { backgroundColor: '#fff' },
        '50%': { backgroundColor: '#26aa01' },
        '100%': { backgroundColor: '#fff' },
    },
}));

function Hero() {
    const [currentSlide, setCurrentSlide] = useState(0)
    const classes = useStyles();
    useEffect(() => {
        let timer = setInterval(() => {
            setCurrentSlide(curr => curr + 1 < bannerImgUrls.length ? curr + 1 : 0)
        }, 4000)

        return () => clearInterval(timer)
    }, [])

    return (
        <HeroWrapper bgimg={bannerImgUrls[currentSlide]}>
            {/* <div className={classes.parentContainer}>
                <div className={classes.infoWrapper}>
                    <img src="https://hsvphry.org.in/assets/img/new_icon.gif" alt="New Icon" className={classes.icon} />
                    <Typography className={classes.info}>Now you can apply for CLU, Mobile Tower Permission, NOC and Appeal through this portal</Typography>
                </div>
            </div> */}
            <HeroTopLeftMessage>Development is about transforming the lives of people</HeroTopLeftMessage>
            <HeroMantriStrip>
                <Grid container spacing={2} wrap="nowrap" justifyContent='center'>
                    {bannerCmStripData.map(({ photo, name, designation }) => (
                        <PersonCard item key={name} xs={12} md={6} lg={3}>
                            <PersonPic>
                                <img src={photo} alt={name} />
                            </PersonPic>
                            <PersonDesc>
                                <strong>{name}</strong>
                                {designation}
                            </PersonDesc>
                        </PersonCard>
                    ))}
                </Grid>
            </HeroMantriStrip>
        </HeroWrapper>
    )
}

export default Hero
